import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bg-white.jpg")